/**
 * @fileoverview ProductoRepository - Repositorio especializado para productos
 */

import { DataRepository } from './base/DataRepository';
import type { Producto, CreateProductoData, UpdateProductoData } from '../types/collections/Producto';
import { RepositoryError } from '../types/common/PocketBaseTypes';

/**
 * Repositorio especializado para la gestión de productos
 * Extiende DataRepository con métodos específicos del dominio
 */
export class ProductoRepository extends DataRepository<Producto> {
  constructor() {
    super('producto');
  }

  /**
   * Obtiene lista de productos activos para autocompletado
   * Retorna solo id y nombre ordenados alfabéticamente
   */
  async getProductosParaAutocompletado(): Promise<{ id: string; nombre: string }[]> {
    try {
      return await this.pb.collection(this.collectionName).getFullList<{ id: string; nombre: string }>({
        filter: 'activo = true',
        sort: 'nombre',
        fields: 'id,nombre',
      });
    } catch (error) {
      throw new RepositoryError(
        `Error al obtener productos para autocompletado: ${error instanceof Error ? error.message : String(error)}`,
        'GET_PRODUCTOS_AUTOCOMPLETE_ERROR',
        error
      );
    }
  }
}

